/* W9 header, Phase 1 (2026-10-24). Markup and the hooks other code relies on: sections/w9-header.liquid. */
(function () {
  'use strict';
  var root = document.querySelector('[data-w9h]');
  if (!root) return;

  var KEY = 'w9_bike';
  var DATA_KEY = 'w9h_bikes_v1';
  var desk = window.matchMedia('(min-width: 990px)');
  var bar = root.querySelector('[data-w9h-bar]');
  var scrim = root.querySelector('[data-w9h-scrim]');
  var drawer = root.querySelector('[data-w9h-drawer]');
  var pop = root.querySelector('[data-w9h-pop]');
  var burger = root.querySelector('[data-w9h-drawer-open]');
  var makeSel = pop.querySelector('[data-w9h-make]');
  var modelSel = pop.querySelector('[data-w9h-model]');
  var MAX = parseInt(root.getAttribute('data-max'), 10) || 12;
  var SORT = root.getAttribute('data-sort') === 'true';

  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function readBike() { try { var b = JSON.parse(localStorage.getItem(KEY) || 'null'); return b && b.label ? b : null; } catch (e) { return null; } }
  function safeUrl(u) { return typeof u === 'string' && /^\/(?!\/)/.test(u) ? u : ''; }
  function attr(s) { return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&'); }

  /* ---- one scrim for an open menu panel, the phone menu or the phone bike sheet ---- */
  var openTab = null;
  var lastOpener = null;
  function sync() {
    var sheet = !pop.hidden && !desk.matches;
    scrim.hidden = !(openTab || !drawer.hidden || sheet);
    document.documentElement.classList.toggle('w9h-lock', !drawer.hidden || sheet);
  }
  function closeAll(restore) {
    setTab(null);
    closePop();
    closeDrawer();
    if (restore && lastOpener && document.contains(lastOpener)) lastOpener.focus();
  }

  /* ---- desktop menu tabs: click opens; while one is open, hovering another switches ---- */
  function setTab(btn) {
    $$('[data-w9h-tab]').forEach(function (b) {
      var on = b === btn;
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
      var p = document.getElementById(b.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
    openTab = btn || null;
    bar.classList.toggle('is-open', !!btn);
    if (btn) { lastOpener = btn; closePop(); }
    sync();
  }
  var hoverAt = 0;
  $$('[data-w9h-tab]').forEach(function (b) {
    b.addEventListener('click', function () {
      /* The pointer usually reaches a tab (and switches to it) just before the click; keep it open, don't toggle it shut. */
      if (openTab === b && Date.now() - hoverAt < 600) return;
      setTab(openTab === b ? null : b);
    });
    b.addEventListener('mouseenter', function () {
      if (openTab && openTab !== b && desk.matches) { setTab(b); hoverAt = Date.now(); }
    });
  });

  /* ---- Shop by bike: the rail picks a bike type ---- */
  function setType(btn) {
    $$('[data-w9h-type]').forEach(function (b) {
      var on = b === btn;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var body = document.getElementById(b.getAttribute('aria-controls'));
      if (body) body.hidden = !on;
    });
  }
  $$('[data-w9h-type]').forEach(function (b) {
    b.addEventListener('click', function () { setType(b); });
    b.addEventListener('mouseenter', function () { setType(b); });
  });

  /* Gas-Moto and other long panels: makes are tiles, one make's models open at a time. */
  function openBrand(btn, on) {
    var body = btn.closest('[data-w9h-typebody]');
    $$('[data-w9h-brand]', body).forEach(function (o) {
      var me = o === btn && on;
      o.setAttribute('aria-expanded', me ? 'true' : 'false');
      var m = document.getElementById(o.getAttribute('data-w9h-brand'));
      if (m) m.hidden = !me;
    });
  }
  $$('[data-w9h-brand]').forEach(function (b) {
    b.addEventListener('click', function () { openBrand(b, b.getAttribute('aria-expanded') !== 'true'); });
  });

  /* Same order as the old menu (window.w9Sort, from w9-global-fixes): makes A-Z, models by engine size then A-Z.
     Bike types and part categories keep the menu order. */
  function sortLists() {
    var S = window.w9Sort;
    if (!SORT || !S) return;
    function label(el) {
      var src = el.querySelector('.w9h__colhead') || el;
      var c = src.cloneNode(true);
      $$('.w9-chip, .w9h__brand-n, [aria-hidden="true"], .w9h__mine', c).forEach(function (x) { x.parentNode.removeChild(x); });
      return S.text(c.textContent);
    }
    $$('[data-w9h-sortbox]').forEach(function (box) { S.sortChildren(box, S.natural, label); });
    $$('[data-w9h-models]').forEach(function (list) { S.sortChildren(list, S.models, label); });
  }

  /* Long model lists show the first MAX, then "+ N more". */
  function capLists() {
    $$('.w9h__list').forEach(function (list) {
      var items = list.children;
      if (items.length <= MAX + 1) return;
      for (var i = MAX; i < items.length; i++) items[i].hidden = true;
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'w9h__more';
      more.textContent = '+ ' + (items.length - MAX) + ' more';
      more.addEventListener('click', function () {
        Array.prototype.forEach.call(list.children, function (li) { li.hidden = false; });
        more.parentNode.removeChild(more);
      });
      list.parentNode.insertBefore(more, list.nextSibling);
    });
  }

  /* ---- phone menu: one level at a time ---- */
  var stack = ['root'];
  function showLvl(id) {
    var cur = null;
    $$('[data-w9h-lvl]', drawer).forEach(function (l) {
      var on = l.getAttribute('data-w9h-lvl') === id;
      l.hidden = !on;
      if (on) cur = l;
    });
    var top = id === 'root';
    $('[data-w9h-back]', drawer).hidden = top;
    $('[data-w9h-drawer-logo]', drawer).hidden = !top;
    if (!top && cur) $('[data-w9h-back-label]', drawer).textContent = cur.getAttribute('data-title') || 'Back';
    $('.w9h__levels', drawer).scrollTop = 0;
  }
  function openDrawer() {
    setTab(null);
    closePop();
    lastOpener = burger;
    stack = ['root'];
    showLvl('root');
    drawer.hidden = false;
    burger.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('is-open'); }); });
    sync();
    $('[data-w9h-drawer-close]', drawer).focus();
  }
  function closeDrawer() {
    if (drawer.hidden) return;
    drawer.classList.remove('is-open');
    drawer.hidden = true;
    burger.setAttribute('aria-expanded', 'false');
    sync();
  }
  burger.addEventListener('click', openDrawer);
  drawer.addEventListener('click', function (e) {
    var down = e.target.closest('[data-w9h-down]');
    if (down) {
      stack.push(down.getAttribute('data-w9h-down'));
      showLvl(stack[stack.length - 1]);
      var back = $('[data-w9h-back]', drawer);
      if (back) back.focus();
      return;
    }
    if (e.target.closest('[data-w9h-back]')) {
      stack.pop();
      showLvl(stack[stack.length - 1] || 'root');
      return;
    }
    if (e.target.closest('[data-w9h-drawer-close]')) closeAll(true);
  });

  /* ---- My bike: popover on desktop, bottom sheet on phones ---- */
  function placePop() {
    if (!desk.matches || pop.hidden) { pop.style.left = ''; pop.style.top = ''; return; }
    var btn = $('.w9h__bikebtn');
    var br = bar.getBoundingClientRect();
    var r = btn.getBoundingClientRect();
    var w = pop.offsetWidth || 340;
    pop.style.left = Math.max(12, Math.min(r.right - br.left - w, br.width - w - 12)) + 'px';
    pop.style.top = (r.bottom - br.top + 8) + 'px';
    pop.style.right = 'auto';
  }
  function openPop(opener) {
    closeDrawer();
    setTab(null);
    lastOpener = opener || null;
    pop.hidden = false;
    $$('[data-w9h-bike-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    placePop();
    sync();
    loadBikes();
    (makeSel.disabled ? $('[data-w9h-pop-close]', pop) : makeSel).focus();
  }
  function closePop() {
    if (pop.hidden) return;
    pop.hidden = true;
    $$('[data-w9h-bike-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    sync();
  }

  var makes = null;
  var loading = false;
  /* Bike type first (2026-10-25, Sheldon): one long make list read as e-moto only on phones, with Gas-Moto
     below the fold. The type buttons pick which makes the Make list shows; UTV is a plain link (no models). */
  var curGroup = '';
  var typeBtns = $$('[data-w9h-group]', pop);
  function setGroup(g) {
    curGroup = g;
    typeBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-w9h-group') === g ? 'true' : 'false'); });
    if (makes) renderMakes();
  }
  typeBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      setGroup(b.getAttribute('data-w9h-group'));
      fillModels(-1);
      if (makes) makeSel.focus();
    });
  });
  /* A model is saved only with its own page, never its make's (2026-10-25, Sheldon). A make that links straight
     to its only model (Y-Volt -> /collections/surge-v) still counts when the page names the model. */
  function cmp(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function handleOf(u) { var m = String(u || '').match(/\/collections\/([^/?#]+)/); return m ? m[1] : ''; }
  function modelOk(m, md) {
    var h = handleOf(md && md.url);
    if (!h) return false;
    var makeLevel = cmp(h) === cmp(m.label) || h === handleOf(m.url);
    return !makeLevel || cmp(h).indexOf(cmp(md.label)) >= 0;
  }
  function renderMakes() {
    if (!curGroup && typeBtns.length) {
      makeSel.innerHTML = '<option value="">Pick a bike type above</option>';
      makeSel.disabled = true;
      return;
    }
    makeSel.innerHTML = '<option value="">Select make</option>';
    makes.forEach(function (m, i) {
      if (typeBtns.length && m.group !== curGroup) return;
      if (!(m.models || []).some(function (md) { return modelOk(m, md); })) return;
      var o = document.createElement('option');
      o.value = String(i);
      o.textContent = m.label;
      makeSel.appendChild(o);
    });
    makeSel.disabled = false;
  }
  function loadBikes() {
    if (makes || loading) return;
    try {
      var cached = JSON.parse(sessionStorage.getItem(DATA_KEY) || 'null');
      if (cached && cached.makes) { fill(cached.makes); return; }
    } catch (e) {}
    loading = true;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(base + '?section_id=w9-bike-data', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var m = html.match(/<script[^>]*data-w9-bike-data[^>]*>([\s\S]*?)<\/script>/);
        var data = JSON.parse(m ? m[1] : 'null');
        if (!data || !data.makes || !data.makes.length) throw new Error('empty');
        try { sessionStorage.setItem(DATA_KEY, JSON.stringify(data)); } catch (e) {}
        fill(data.makes);
      })
      .catch(function () {
        makeSel.innerHTML = '<option value="">Unavailable</option>';
        $('[data-w9h-pop-err]', pop).hidden = false;
      })
      .then(function () { loading = false; });
  }
  /* Same order as the bike finder: makes A-Z inside their group (Gas-Moto, E-Moto), models by engine size. */
  function fill(list) {
    var S = window.w9Sort;
    makes = list.filter(function (m) { return m && m.label; });
    if (S) {
      var gi = {};
      makes.forEach(function (m) { if (!(m.group in gi)) gi[m.group] = Object.keys(gi).length; });
      makes.sort(function (a, b) { return (gi[a.group] - gi[b.group]) || S.natural(a.label, b.label); });
      makes.forEach(function (m) { (m.models || []).sort(function (a, b) { return S.models(a.label, b.label); }); });
    }
    var b = readBike();
    var mi = -1;
    if (b && b.make) makes.some(function (m, i) { if (m.label === b.make) { mi = i; return true; } return false; });
    if (mi >= 0 && !curGroup) setGroup(makes[mi].group);
    else renderMakes();
    if (mi >= 0 && makes[mi].group === curGroup) makeSel.value = String(mi);
    else mi = -1;
    fillModels(mi, b && b.model);
    if (!pop.hidden && document.activeElement === $('[data-w9h-pop-close]', pop) && !makeSel.disabled) makeSel.focus();
  }
  function fillModels(i, want) {
    modelSel.innerHTML = '<option value="">Select model</option>';
    var m = makes && makes[i];
    if (!m || !m.models || !m.models.length) { modelSel.disabled = true; return; }
    m.models.forEach(function (md, j) {
      if (!modelOk(m, md)) return;
      var o = document.createElement('option');
      o.value = String(j);
      o.textContent = md.label;
      if (want && md.label === want) o.selected = true;
      modelSel.appendChild(o);
    });
    modelSel.disabled = false;
  }
  makeSel.addEventListener('change', function () { fillModels(parseInt(makeSel.value, 10)); });

  /* Saved exactly like the bike finder, so the fit check, cart drawer and part pages all read it. */
  $('[data-w9h-bike-form]', pop).addEventListener('submit', function (e) {
    e.preventDefault();
    var m = makes && makes[parseInt(makeSel.value, 10)];
    if (!m) { if (makeSel.disabled && typeBtns.length) typeBtns[0].focus(); else makeSel.focus(); return; }
    var md = m.models[parseInt(modelSel.value, 10)];
    function ok(u) { return u && u.charAt(0) !== '#'; }
    var target = md && ok(md.url) && modelOk(m, md) ? md.url : null;
    if (!target) { modelSel.focus(); return; }
    var bike = { label: md ? m.label + ' ' + md.label : m.label, url: target, make: m.label, model: md ? md.label : '' };
    try { localStorage.setItem(KEY, JSON.stringify(bike)); } catch (err) {}
    /* On a product page, reload so the fit check answers for the new bike; anywhere else, go to its parts. */
    if (document.body.classList.contains('template-product')) window.location.reload();
    else window.location.href = target;
  });

  /* ---- reflect the saved bike everywhere in the header ---- */
  function markMine(b) {
    $$('.is-mine').forEach(function (el) { el.classList.remove('is-mine'); });
    $$('.w9h__mine').forEach(function (el) { el.parentNode.removeChild(el); });
    if (!b || !b.make) return;
    var sel = '[data-make="' + attr(b.make) + '"]';
    $$(sel).forEach(function (box) {
      if (box.classList.contains('w9h__brand')) box.classList.add('is-mine');
      if (!b.model) return;
      $$('a[data-model="' + attr(b.model) + '"]', box).forEach(function (a) {
        a.classList.add('is-mine');
        var s = document.createElement('span');
        s.className = 'w9h__mine';
        s.textContent = ' · your bike';
        a.appendChild(s);
      });
    });
  }
  function pickType(b) {
    var types = $$('[data-w9h-type]');
    if (!types.length) return;
    var target = types[0];
    var sel = b && b.make ? '[data-make="' + attr(b.make) + '"]' : '';
    if (sel) {
      types.some(function (t) {
        var body = document.getElementById(t.getAttribute('aria-controls'));
        if (body && body.querySelector(sel)) { target = t; return true; }
        return false;
      });
    }
    setType(target);
    if (sel) {
      var body = document.getElementById(target.getAttribute('aria-controls'));
      var brand = body && body.querySelector('.w9h__brand[data-w9h-brand]' + sel);
      if (brand) openBrand(brand, true);
    }
  }
  function render() {
    var b = readBike();
    var short = b ? (b.model || b.label) : '';
    var url = b ? safeUrl(b.url) : '';
    document.documentElement.classList.toggle('w9h-bike', !!b);

    $('.w9h__bikebtn').classList.toggle('is-saved', !!b);
    $('[data-w9h-bike-name]').textContent = b ? b.label : 'Select your bike';

    var chip = $('[data-w9h-chip-bike]');
    chip.classList.toggle('is-saved', !!b);
    chip.textContent = b ? '✓ ' + short : '+ My bike';
    var mine = $('[data-w9h-chip-mine]');
    mine.hidden = !url;
    if (url) { mine.href = url; mine.textContent = short + ' parts'; }

    var card = $('[data-w9h-card]', drawer);
    card.classList.toggle('is-saved', !!b);
    $('[data-w9h-card-name]', drawer).textContent = b ? b.label : 'No bike saved';
    var shop = $('[data-w9h-card-shop]', drawer);
    shop.hidden = !url;
    if (url) { shop.href = url; shop.textContent = 'Shop ' + short + ' parts ›'; }
    $('[data-w9h-card-pick]', drawer).textContent = b ? 'Change' : 'Pick your bike ›';

    $('[data-w9h-saved]', pop).hidden = !b;
    if (b) {
      $('[data-w9h-saved-name]', pop).textContent = b.label;
      var sl = $('[data-w9h-saved-link]', pop);
      sl.hidden = !url;
      if (url) { sl.href = url; sl.textContent = 'Shop all ' + short + ' parts ›'; }
    }
    $('[data-w9h-pop-title]', pop).textContent = b ? 'Change bike' : 'Save your bike and the menus show what fits it.';
    $('[data-w9h-forget]', pop).hidden = !b;

    var scope = $('[data-w9h-part-scope]');
    if (scope) scope.textContent = b ? '· opens filtered to your ' + short + ' where we list fits' : '';
    $$('[data-w9h-all-parts]').forEach(function (a) {
      var label = a.querySelector('[data-w9h-all-label]');
      a.href = url || a.getAttribute('data-default');
      if (label) label.textContent = url ? 'All ' + short + ' parts' : 'All parts';
    });

    markMine(b);
    pickType(b);
  }

  /* "Forget this bike" also carries .w9-hbike__clear: w9-global-fixes clears the bike and resets any finder.
     Clear it here too in case that section is off, then redraw. */
  $('[data-w9h-forget]', pop).addEventListener('click', function () {
    setTimeout(function () {
      try { localStorage.removeItem(KEY); } catch (e) {}
      render();
      closePop();
      if (makes) { makeSel.value = ''; fillModels(-1); }
    }, 0);
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) render(); });
  document.addEventListener('w9:bike-cleared', render);

  /* ---- shared listeners ---- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var tog = t.closest && t.closest('[data-w9h-bike-toggle]');
    if (tog) {
      e.preventDefault();
      if (pop.hidden) openPop(tog); else closePop();
      return;
    }
    if (t.closest && t.closest('[data-w9h-pop-close]')) { closePop(); if (lastOpener) lastOpener.focus(); return; }

    /* Chat links open the Ask Warp 9 widget when it's on the page; otherwise they go to the contact page. */
    var chat = t.closest && t.closest('[data-w9h-chat]');
    if (chat) {
      var w = document.querySelector('ask-warp9');
      var launcher = w && w.shadowRoot && w.shadowRoot.querySelector('.launcher');
      if (launcher) { e.preventDefault(); closeAll(false); launcher.click(); }
      return;
    }

    if (t === scrim) { closeAll(true); return; }
    if (openTab && !bar.contains(t)) setTab(null);
    if (!pop.hidden && desk.matches && !pop.contains(t)) closePop();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (openTab || !pop.hidden || !drawer.hidden) closeAll(true);
  });
  var onBp = function () { closeAll(false); };
  if (desk.addEventListener) desk.addEventListener('change', onBp); else if (desk.addListener) desk.addListener(onBp);
  window.addEventListener('resize', placePop);

  sortLists();
  capLists();
  render();
})();
